import $ from 'jquery'
import { initASwap } from './aswap'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'


const onLoadingComplete = () => {
  initASwap()
  document.documentElement.classList.remove("index-loading")
}

const initIntro = (el) => {
  initASwap()
  setTimeout(() => {
    document.documentElement.classList.remove("index-loading")
  }, 800)
}

export const loadingSequence = () => {
  const box = document.getElementById("box-loading")
  if (box) {
    initIntro(box)
  } else {
    onLoadingComplete()
  }
  
}